import { startUIListeners } from "./listeners"
import { IUIService } from "./model"
import { closeColorPickerPopup, openColorPickerPopup } from "./tools/color-picker-popup"
import { isDarkThemeActive, setTheme } from "./tools/theme"

startUIListeners()

export const uiSVC: IUIService = {
  setDarkThemeActive: setTheme,
  isDarkThemeActive,
  openColorPickerPopup,
  closeColorPickerPopup
}
